import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import TFPAPolicyDetailsPage from './pages/PolicyDetails/PolicyDetailsPage.jsx';
import TFPAQualificationPage from 'ent-capability-quoteandbind-common-react/pages/Qualification/QualificationPage.jsx';
import TFPAPropertyDetailsPage from './pages/PropertyDetails/PropertyDetailsPage';
import TFPAConstructionPage from './pages/Construction/ConstructionPage';
import TFPAQuotePage from './pages/Quote/QuotePage';
import TFPAAdditionalInformationPage from './pages/AdditionalInformation/AdditionalInformationPage';
import TFPACoverageSummaryPage from './pages/CoverageSummary/CoverageSummaryPage';
import TFPAPaymentDetailsPage from './pages/PaymentDetails/PaymentDetailsPage';
import TFPADiscountsPage from './pages/Discounts/DiscountsPage';

setComponentMapOverrides(
    {
        TFPAPolicyDetailsPage: { component: 'TFPAPolicyDetailsPage' },
        TFPAQualificationPage: { component: 'TFPAQualificationPage' },
        TFPAPropertyDetailsPage: { component: 'TFPAPropertyDetailsPage' },
        TFPAConstructionPage: { component: 'TFPAConstructionPage' },
        TFPAQuotePage: { component: 'TFPAQuotePage' },
        TFPAAdditionalInformationPage: { component: 'TFPAAdditionalInformationPage' },
        TFPACoverageSummaryPage: { component: 'TFPACoverageSummaryPage' },
        TFPAPaymentDetailsPage: { component: 'TFPAPaymentDetailsPage' },
        TFPADiscountsPage: {component: 'TFPADiscountsPage'},
    },
    {
        TFPAPolicyDetailsPage,
        TFPAQualificationPage,
        TFPAPropertyDetailsPage,
        TFPAConstructionPage,
        TFPAQuotePage,
        TFPAAdditionalInformationPage,
        TFPACoverageSummaryPage,
        TFPAPaymentDetailsPage,
        TFPADiscountsPage,
    }
);


export { default as TFPAResidentialWizard } from './TFPAResidentialWizard.jsx';
export { default as TWIAAccountHolderEdit } from './components/TWIAAccountHolderEdit/TWIAAccountHolderEdit.jsx';
